<!-- 
    Purpose: To show the mobile view of task list
-->

<template>
  <div>
    <v-navigation-drawer
      :width="280"
      right
      fixed
      app
      temporary
      hide-overlay
      :style="
        !isExtension && $vuetify.breakpoint.xs ? 'margin-top: 60px' : '0px'
      "
      :class="isExtension ? 'ext-margin' : 'non-ext-margin'"
      height="calc(108vh - 60px)"
      v-model="flag"
    >
      <div class="d-flex align-center" :style="{ background: '#F8F7FD' }">
        <h3 class="dark-purple-text px-3 pt-3 pb-2">Customize Columns</h3>
        <v-spacer></v-spacer
        ><v-icon @click="flag = false" class="pointer mx-4 close-btn" small
          >mdi-close</v-icon
        >
      </div>

      <div v-if="$route.path == '/task'">
        <v-card
          class="mt-5 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyColumn('sr_no')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getTaskColumn('sr_no')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Ticket</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyColumn('due_date')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getTaskColumn('due_date')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Due date</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyColumn('priority')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getTaskColumn('priority')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Priority</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyColumn('status')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getTaskColumn('status')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Status</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyColumn('members.duration')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getTaskColumn('members.duration')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Duration</h3>
        </v-card>

        <div v-if="!$vuetify.breakpoint.xs">
          <v-card
            class="mt-2 d-flex py-1 mx-auto"
            max-width="240"
            outlined
            @click="applyColumn('created_at')"
          >
            <v-card-actions>
              <v-icon color="success" v-if="!getTaskColumn('created_at')"
                >mdi-checkbox-blank-outline</v-icon
              >
              <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
            </v-card-actions>
            <h3 class="dark-purple-text text-capitalize pa-2">Assigned Date</h3>
          </v-card>

          <v-card
            class="mt-2 d-flex py-1 mx-auto"
            max-width="240"
            outlined
            @click="applyColumn('added_at')"
          >
            <v-card-actions>
              <v-icon color="success" v-if="!getTaskColumn('added_at')"
                >mdi-checkbox-blank-outline</v-icon
              >
              <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
            </v-card-actions>
            <h3 class="dark-purple-text text-capitalize pa-2">Activity Date</h3>
          </v-card>

          <div v-if="getShowAllTasks != 'me'">
            <v-card
              class="mt-2 d-flex py-1 mx-auto"
              max-width="240"
              outlined
              @click="applyColumn('members')"
            >
              <v-card-actions>
                <v-icon color="success" v-if="!getTaskColumn('members')"
                  >mdi-checkbox-blank-outline</v-icon
                >
                <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
              </v-card-actions>
              <h3 class="dark-purple-text text-capitalize pa-2">Assignee</h3>
            </v-card>
          </div>

          <v-card
            class="mt-2 d-flex py-1 mx-auto"
            max-width="240"
            outlined
            @click="applyColumn('assigned_by')"
          >
            <v-card-actions>
              <v-icon color="success" v-if="!getTaskColumn('assigned_by')"
                >mdi-checkbox-blank-outline</v-icon
              >
              <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
            </v-card-actions>
            <h3 class="dark-purple-text text-capitalize pa-2">Assigner</h3>
          </v-card>
        </div>
      </div>

      <div v-if="$route.path == '/member'">
        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('email')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('email')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Email</h3>
        </v-card>
        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('role')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('role')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Role</h3>
        </v-card>
        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('designation')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('designation')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Designation</h3>
        </v-card>
        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('department')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('department')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Department</h3>
        </v-card>
        <v-card
          v-if="getSelectedCompany.role != 'team-manager'"
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('lead')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('lead')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Lead</h3>
        </v-card>
        <v-card
          v-if="getSelectedCompany.role != 'team-manager'"
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('project')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('project')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Project</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('today_time')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('today_time')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Today Time</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('weekly_time')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('weekly_time')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Weekly Time</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('monthly_time')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('monthly_time')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Monthly Time</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('completed')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('completed')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Completed</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('pending')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('pending')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Pending</h3>
        </v-card>

        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyMemberColumn('overdue')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getMemberColumn('overdue')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Overdue</h3>
        </v-card>
      </div>

      <!-- Reports Columns -->

      <div v-if="$route.path == '/reports'">
        <v-card
          v-if="getReportsView == 'user'"
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyReportColumn('role')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getReportColumn('role')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Role</h3>
        </v-card>
        <v-card
          v-if="
            getReportsView == 'user' ||
              getReportsView == 'leader' ||
              getReportsView == 'project'
          "
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyReportColumn('department')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getReportColumn('department')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Department</h3>
        </v-card>
        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyReportColumn('designation')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getReportColumn('designation')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Designation</h3>
        </v-card>
        <v-card
          v-if="getReportsView != 'project'"
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyReportColumn('to_others')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getReportColumn('to_others')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">To Others</h3>
        </v-card>
        <v-card
          v-if="getReportsView != 'project'"
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyReportColumn('by_others')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getReportColumn('by_others')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">By Others</h3>
        </v-card>
        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyReportColumn('completed')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getReportColumn('completed')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Completed</h3>
        </v-card>
        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyReportColumn('pending')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getReportColumn('pending')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Pending</h3>
        </v-card>
        <v-card
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyReportColumn('overdue')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getReportColumn('overdue')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Overdue</h3>
        </v-card>
        <v-card
          v-if="getReportsView != 'project'"
          class="mt-2 d-flex py-1 mx-auto"
          max-width="240"
          outlined
          @click="applyReportColumn('expired')"
        >
          <v-card-actions>
            <v-icon color="success" v-if="!getReportColumn('expired')"
              >mdi-checkbox-blank-outline</v-icon
            >
            <v-icon color="success" v-else>mdi-checkbox-marked</v-icon>
          </v-card-actions>
          <h3 class="dark-purple-text text-capitalize pa-2">Expired</h3>
        </v-card>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { eventBus } from "@/main";

export default {
  name: "MobileTaskColumns",
  props: ["drawer"],

  methods: {
    applyColumn(key) {
      let payload = {};
      payload[key] = !this.getTaskColumn(key);
      this.$store.commit("setTaskColumn", payload);
    },

    applyMemberColumn(key) {
      let payload = {};
      payload[key] = !this.getMemberColumn(key);
      this.$store.commit("setMemberColumn", payload);
    },

    applyReportColumn(key) {
      let payload = {};
      payload[key] = !this.getReportColumn(key);
      this.$store.commit("setReportColumn", payload);
    },
  },
  computed: {
    ...mapGetters([
      "getActiveTask",
      "getSelectedCompany",
      "getShowAllTasks",
      "getSelectedProject",
      "getLoggedInUser",
      "getActiveTimeEntry",
      "getQueue",
      "getTaskColumns",
      "getTaskColumn",
      "getOnlineStatus",
      "getSidebarMini",
      "getView",
      "getPendingTimer",
      "getBadgedStatus",
      "getTasks",
      "getMemberColumn",
      "getReportColumn",
      "getReportsView",
    ]),
  },
  data() {
    return {
      flag: false,
      color: "success",
    };
  },
  watch: {
    drawer(value) {
      if (value) {
        this.flag = true;

        this.$store.commit("setDisableFlag", {
          disableflag: true,
        });
      }
    },
    flag(value) {
      if (!value) {
        this.$emit("update:drawer", false);
        this.$store.commit("setDisableFlag", {
          disableflag: false,
        });
      }
    },
  },
};
</script>

<style scoped>
.dropdown-header {
  color: #6f7490 !important;
}
.radio-item input[type="radio"] {
  display: none;
}
.radio-item label:before {
  content: " ";
  display: inline-block;
  position: relative;
  top: 2px;
  margin: 0 5px 0 0;
  width: 14px;
  height: 14px;
  border-radius: 11px;
  border: 2px solid #1cc283;
  background-color: transparent;
}

.radio-item input[type="radio"]:checked + label:after {
  border-radius: 11px;
  width: 6px;
  height: 6px;
  position: relative;
  top: -14px;
  left: 8px;
  content: " ";
  display: block;
  background: #1cc283;
}
</style>
